<template>
  <v-container fluid grid-list-xl>
    <v-layout row>
      <v-flex xs12 sm6 offset-sm3>
        <v-card>
          <v-progress-linear :active="loading" height="3" indeterminate></v-progress-linear>
          <v-toolbar card color="white">
            <v-flex>
              <v-text-field
                flat
                hide-details
                :placeholder="$t('search')"
                prepend-icon="search"
                solo
                v-model="search"
              ></v-text-field>
            </v-flex>
          </v-toolbar>
          <v-divider></v-divider>

          <v-list two-line>
            <template v-for="(course, index) in courses">
              <v-divider v-if="index != 0" :key="index+600" inset></v-divider>

              <v-list-tile :key="index+300" avatar @click="openCourse(course._id)">
                <v-list-tile-content>
                  <v-list-tile-title v-html="course.name"></v-list-tile-title>
                  <v-list-tile-sub-title
                    class="grey--text text--lighten-1"
                  >{{$t('createdAt')}}&nbsp;{{formatDate(course.createdAt)}}</v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action-text>
                  <span v-if="loading && selected == course._id">
                    <v-progress-circular :size="20" :width="3" color="primary" indeterminate></v-progress-circular>
                  </span>
                  <span v-else>
                    <p style="margin-bottom: 5px;">{{$t('updatedAt')}}</p>
                    <p>{{formatDate(course.updatedAt)}}</p>
                  </span>
                </v-list-tile-action-text>
              </v-list-tile>
            </template>
          </v-list>
        </v-card>
      </v-flex>
    </v-layout>
    <dialog-course :dialog.sync="dialog"/>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import DialogCourse from './DialogCourse'
export default {
  name: 'tabCourses',
  components: { DialogCourse },
  data () {
    return {
      search: '',
      selected: '',
      loading: false,
      dialog: false
    }
  },
  computed: {
    ...mapState({
      courseList: state => state.courses.list
    }),
    courses () {
      let activeCourses = this.courseList.filter(course => course.active)
      return this.filterArray(activeCourses, this.search)
    }
  },
  methods: {
    ...mapActions({
      getOne: 'courses/setOne'
    }),
    openCourse (id) {
      this.selected = id
      this.loading = true
      this.getOne(id).then((result) => {
        this.dialog = true
      }).finally((err) => {
        this.loading = false
      })
    }
  }
}
</script>

<style scoped lang="scss">
.v-content {
}
</style>
